import { store } from 'Store/index'
import { getFileMetaData } from 'Api/drives.api'

export default class SharePointService {
  constructor() {
    this.isSyncingFile = false
    this.fileMetaDataInterval = null
    this.lastModifiedDateTime = null
  }
  getFileMetaData(params) {
    return getFileMetaData(params)
  }
  setIntervalForFileMetaData({ driveId, itemId, callback }) {
    if (this.fileMetaDataInterval) {
      return
    }

    let retryNum = 0

    this.fileMetaDataInterval = setInterval(async () => {
      try {
        let res = await this.getFileMetaData({ driveId, itemId })
  
        retryNum = 0
        callback && callback(res)
      } catch (errorRes) {
        retryNum++

        store.driveStore.sharePointRefreshTokenHandler()

        if (retryNum > 2) {
          retryNum = 0
          this.cleanIntervalForFileMetaData()
        }
      }
    }, 10000)
  }
  hasNewUpdateForFile({ driveId, itemId, callback }) {
    this.setIntervalForFileMetaData({
      driveId, itemId, callback: (res) => {
        if (res.lastModifiedDateTime > this.lastModifiedDateTime) {
          // show modal
          console.log('new');
          this.cleanIntervalForFileMetaData()
          callback && callback(res)
        } else {
          console.log('no');
        }
      }
    })
  }
  cleanIntervalForFileMetaData() {
    clearInterval(this.fileMetaDataInterval)
    this.fileMetaDataInterval = null
  }
  updateLastModifiedDateTime(value) {
    this.lastModifiedDateTime = value
  }
  updateIsSyncingFile(value) {
    this.isSyncingFile = value
  }
}